<div class="wrapper">
  <app-text-input
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="activityId"
    label="activity Id"
  />
  <app-text-input
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="name"
    label="name"
  />
  <app-text-input
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="location"
    label="location"
  />
  <app-text-input
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="segment"
    label="segment"
  />
</div>
